import React, { useCallback, useEffect, useState } from 'react';
import { hrefForSameSiteAsset, mediaUrlWithWidth } from '../productMediaUtils';

/**
 * Product/category image from DB path only. Renders a neutral placeholder when missing.
 * Optional `maxWidth` requests a serve_upload.php?w= JPEG thumb (grid / shelves).
 */
export default function CatalogImage({
  src,
  alt = '',
  className = '',
  loading = 'lazy',
  sizes,
  style,
  maxWidth,
  decoding = 'async',
}) {
  const path = String(src || '').trim();
  const full = path ? hrefForSameSiteAsset(path) : '';
  const preferred = maxWidth && full ? mediaUrlWithWidth(full, maxWidth) || full : full;
  const [current, setCurrent] = useState(preferred);

  useEffect(() => {
    setCurrent(preferred);
  }, [preferred]);

  const onError = useCallback(() => {
    if (current && full && current !== full) {
      setCurrent(full);
    }
  }, [current, full]);

  if (!path || !full) {
    return (
      <div
        className={`catalog-media-placeholder ${className}`.trim()}
        style={style}
        role="img"
        aria-label={alt || 'No image'}
      />
    );
  }

  return (
    <img
      key={current}
      src={current}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      sizes={sizes}
      style={style}
      onError={onError}
    />
  );
}
